import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
export default function RadioExample() {
    const [value, setValue] = React.useState('female');
    const handleChange = (event) => {
        setValue(event.target.value);
    };
    return (_jsxs(FormControl, Object.assign({ component: "fieldset" }, { children: [_jsx(FormLabel, Object.assign({ component: "legend" }, { children: "Gender" })), _jsxs(RadioGroup, Object.assign({ "aria-label": "gender", name: "gender1", value: value, onChange: handleChange }, { children: [_jsx(FormControlLabel, { value: "female", control: _jsx(Radio, {}), label: "Female" }), _jsx(FormControlLabel, { value: "male", control: _jsx(Radio, {}), label: "Male" }), _jsx(FormControlLabel, { value: "other", control: _jsx(Radio, {}), label: "Other" }), _jsx(FormControlLabel, { value: "disabled", disabled: true, control: _jsx(Radio, {}), label: "(Disabled option)" })] }))] })));
}
